
















import Vue from 'vue';
import { Loader } from 'mycorems-app-shared';
import { UserRole } from '../types';
import userRepository from '../user/user-repository';
import RolesList from '../role/RolesList.vue';
import { assign, unassign } from '.';
import { getAccountType } from '../user';

interface Data {
  task: Promise<any[]>|null,
  isLoading: boolean,
  accountType: number|null,
  userRole: UserRole|null,
}

export default Vue.extend({
  components: { Loader, RolesList },
  props: {
    userId: {
      type: String,
      required: true,
    },
    serviceId: {
      type: String,
      default: null, // Important for equality check below
    },
    // Only show roles that are assignable by app user
    showAssignable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      isLoading: false,
      accountType: null,
      userRole: null,
    };
  },
  computed: {
    roleId(): string|null {
      return this.userRole ? this.userRole.role.id : null;
    },
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    loadAccountType(): Promise<void> {
      return getAccountType(this.userId).then((accountType) => {
        this.accountType = accountType;
      });
    },
    loadUserRole(): Promise<void> {
      return userRepository
        .find(this.userId)
        .then((user) => {
          this.userRole = user.roles.find(ur => ur.role.serviceId === this.serviceId) || null;
        });
    },
    load() {
      this.isLoading = true;
      this.task = Promise.all([
        this.loadAccountType(),
        this.loadUserRole(),
      ]);
      this.task.finally(() => {
        this.isLoading = false;
      });
    },
    assign(roleId: string) {
      assign(this.userId, roleId).then((userRole) => {
        if (this.userRole) {
          this.$emit('unassigned', this.userRole);
        }
        this.userRole = userRole;
        this.$emit('assigned', userRole);
      });
    },
    unassign() {
      if (!this.userRole) return;
      unassign(this.userRole.id).then(() => {
        this.$emit('unassigned', this.userRole);
        this.userRole = null;
      });
    },
  },
});
